// @flow
import * as React from 'react';
import {Route, Redirect, Switch, useHistory, useRouteMatch} from 'react-router-dom';
import IntroB from './IntroB';
import ChargingStation from './ChargingStation';
import ChargingStationA from './ChargingStationA';
import ChargingStationB from './ChargingStationB';
import ChargingStationC from './ChargingStationC';
import ChargingStationD from './ChargingStationD';
import InCarExperience from './InCarExperience';
import DrivingExperience from './DrivingExperience';
import ModalIndex from './ModalIndexB';
import * as VRUtils from 'utils/vrUtils';
import Map from '../Map';
import Loading from '../../Loading';
import * as AudioUtils from 'utils/audioUtils';

// function NoBGM() : any {
//   React.useEffect(() => {
//     AudioUtils.stopBGM();

//     return function(){
//     };

//   }, []);
//   return null;
// }

function BGM() : any {
  React.useEffect(() => {
    AudioUtils.playBGM_UI2();

    return function(){
    };

  }, []);
  return null;
}

export default function CourseB(): React.Element<any> {
  const history = useHistory();
  const {path, url} = useRouteMatch();
  const [openModalIndex, setOpenModalIndex] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleOpenModalIndex = React.useCallback(() => {
    setOpenModalIndex(true);
  }, []);

  const handleCloseModalIndex = React.useCallback(() => {
    setOpenModalIndex(false);
  }, []);

  React.useEffect(() => {
    setIsLoading(true);
    VRUtils.loadScene("course_b", [], () => {
      setIsLoading(false);
      
    });
    console.log("audio: stopping BGM");
    AudioUtils.stopBGM();

    return function(){
      window.videoPlayer.unload();
    };

  }, []);

  return (
    <React.Fragment>
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${url}/intro`} />
        </Route>
        <Route path={`${url}/intro`}>
          <IntroB
            onOpenModalIndex={handleOpenModalIndex}
            onCloseModalIndex={handleCloseModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/charging-station`)}
            onSkip={() => {history.push(`${url}/charging-station-d`)}}
          />
          <BGM />
        </Route>
        <Route path={`${url}/charging-station`}>
          <ChargingStation
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/charging-station-a`)}
            onSkip={() => {history.push(`${url}/charging-station-d`)}}
          />
        </Route>
        <Route path={`${url}/charging-station-a`}>
          <ChargingStationA
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/charging-station-b`)}
            onSkip={() => {window.tagManager.courseBIntroSkipChargingLinkClick(); history.push(`${url}/charging-station-d`)} }
          />
          <BGM />
        </Route>
        <Route path={`${url}/charging-station-b`}>
          <ChargingStationB
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/charging-station-c`)}
            onSkip={() => {window.tagManager.courseBIntroSkipChargingLinkClick(); history.push(`${url}/charging-station-d`)} }
          />
          <BGM />
        </Route>
        <Route path={`${url}/charging-station-c`}>
          <ChargingStationC
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/charging-station-d`)}
            onSkip={() => {window.tagManager.courseBIntroSkipChargingLinkClick(); history.push(`${url}/charging-station-d`)} }
          />
          <BGM />
        </Route>
        <Route path={`${url}/charging-station-d`}>
          <ChargingStationD
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/in-car-experience`)}
            onSkip={() => {history.push(`${url}/in-car-experience`)} }
          />
          <BGM />
        </Route>
        <Route path={`${url}/in-car-experience`}>
          <InCarExperience
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/driving-experience`)}
          />
          
        </Route>
        <Route path={`${url}/driving-experience`}>
          <DrivingExperience 
            onOpenModalIndex={handleOpenModalIndex}
            openModalIndex={openModalIndex}
            onNext={() => history.push(`${url}/map`)} />
          <BGM />
        </Route>
        <Route path={`${url}/map`}>
          <main><Map onNextA={() => history.push('/driving-zone/course-a/play')} onNextB={() => history.push(`${url}/intro`)} isHidden={openModalIndex} onOpenModalIndex={handleOpenModalIndex} /></main>
          <BGM />
        </Route>
        <Redirect to={path} />
      </Switch>
      <ModalIndex open={openModalIndex} onClose={() => setOpenModalIndex(false)} />
      {isLoading && <Loading />}
    </React.Fragment>
  );
}
